import React from 'react';
import BadgeMenuSelect from './BadgeMenuSelect';

/**
 * États de paiement proposés dans la liste des demandes : ceux que le système pose déjà, orthographe exacte (l'appli
 * client compare ces chaînes). '' = aucun (eVisa, dossiers créés à la main…). Même liste que ETATS_PAIEMENT du backend
 * admin (server.js, PUT /demandes/:id/paiement), qui refuse toute autre valeur.
 */
export const ETATS_PAIEMENT = [
  'payé',
  'virement',
  'attente paiement',
  'Attente facturation',
  'à facturer',
  'remboursé',
  'annulé',
  ''
] as const;

interface EtatPaiementSelectProps {
  /** Valeur actuelle (etat_paiement), éventuellement hors liste (ex. « Attente paiement » posé par l'appli client) */
  value: string;
  /** Couleur associée à un état de paiement */
  getColor: (etat: string) => string;
  /** Appelé quand l'utilisateur choisit un autre état */
  onChange: (nouvelEtat: string) => Promise<void> | void;
  /** Taille du texte affiché au repos (px) */
  fontSize?: number;
}

/**
 * Badge de paiement cliquable (même comportement que le badge d'état) : au repos, l'état coloré (« — » si aucun) ;
 * au clic, le menu des états de paiement. La coche ignore la casse (« Attente paiement » = « attente paiement »).
 */
const EtatPaiementSelect: React.FC<EtatPaiementSelectProps> = ({ value, getColor, onChange, fontSize = 14 }) => (
  <BadgeMenuSelect
    value={value || ''}
    options={ETATS_PAIEMENT}
    getColor={getColor}
    onChange={onChange}
    label={value || '—'}
    libelleOption={(option) => option || '(aucun)'}
    estSelectionnee={(option, v) => option.toLowerCase() === v.toLowerCase()}
    title="Cliquer pour changer l'état de paiement"
    fontSize={fontSize}
  />
);

export default EtatPaiementSelect;
